export default __webpack_public_path__ + "static/media/gooPahJumpThumb.59336e8c.png";